import React from 'react'

interface IPhoneSdCardIconProps {
  size?: number
  color?: string
}

const PhoneSdCardIcon: React.FC<IPhoneSdCardIconProps> = ({ size = 36, color = '#2E7D32' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M0,0H64V64H0Z" fill="none" />
    <path
      d="M34.333,1H13A7.989,7.989,0,0,0,5,9V51.667a7.989,7.989,0,0,0,8,8H34.333a7.989,7.989,0,0,0,8-8V9A7.989,7.989,0,0,0,34.333,1ZM37,46.333H10.333V9H37Zm-8,8H18.333V51.667H29Z"
      transform="translate(8.333 1.667)"
      fill={color}
    />
    <path
      d="M7,2A1.552,1.552,0,0,0,5.5,3.6V9.2L4,10.8v5.6A1.552,1.552,0,0,0,5.5,18h9A1.552,1.552,0,0,0,16,16.4V3.6A1.552,1.552,0,0,0,14.5,2H7m.75,1.6h1.5V6.8H7.75V3.6M10,3.6h1.5V6.8H10V3.6m2.25,0h1.5V6.8h-1.5Z"
      transform="translate(22 22)"
      fill={color}
    />
  </svg>
)

export default PhoneSdCardIcon
